
import { useCallback, useState } from "react";
import { db, auth } from "../firebase";
import { collection, doc, setDoc, serverTimestamp } from "firebase/firestore";

export function useRegRequests() {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);
  const [lastUid, setLastUid] = useState(null);

  const createRegRequest = useCallback(async (formData) => {
    setLoading(true);
    setError(null);
    setLastUid(null);

    try {
      // ✅ Get a document ref (even segments) for anchor
      const anchorDocRef   = doc(db, "admin", "regrequest"); // 2 segments → doc
      // ✅ Get a subcollection from the doc (odd segments)
      const requestsColRef = collection(anchorDocRef, "requests"); // → collection
      const requestDocRef  = doc(requestsColRef); // auto-ID
      const uid            = requestDocRef.id;

      const payload = {
        communityName: String(formData.communityName || "").trim(),
        city:          String(formData.city || "").trim(),
        totalFlats:    Number(formData.totalFlats || 0),
        contactName:   String(formData.contactName || "").trim(),
        email:         String(formData.email || "").trim().toLowerCase(),
        phone:         String(formData.phone || "").trim(),
        status:        "new",
        uid,
        createdAt:     serverTimestamp(),
        createdBy:     auth.currentUser ? auth.currentUser.uid : null,
      };

      await setDoc(requestDocRef, payload);
      setLastUid(uid);
      return { uid };
    } catch (err) {
      console.error("createRegRequest failed:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { createRegRequest, loading, error, lastUid };
}
